export { default } from './OfferCard';
export * from './OfferCard';
